import "./DeducaoTable.css";

interface AtrasoDocRow {
  dataEnvio?: string;
  dataLimite?: string;
  diasAtraso?: number;
  percentual?: number;
  valorApoio?: string;
  valorDeducao?: string;
}

interface TituloRow {
  filial?: string;
  titulo?: string;
  natureza?: string;
  emissao?: string;
  vencimento?: string;
  atrasoDias?: number;
  valor?: string;
  historico?: string;
}

interface OutraDeducaoRow {
  descricao: string;
  valor: number;
}

export interface DeducaoTableModelProps {
  atrasoDocs?: AtrasoDocRow[];
  titulosEmAberto?: TituloRow[];
  outrasDeducoes?: OutraDeducaoRow[];
  totalAtraso?: string;
  totalTitulos?: string;
  totalOutras?: string;
  totalGeral?: string;
  liquidoApoio?: string;
}

const formatar = (valor: number): string =>
  valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const DeducaoTable = ({
  atrasoDocs = [],
  titulosEmAberto = [],
  outrasDeducoes = [],
  totalAtraso = "R$0,00",
  totalTitulos = "R$0,00",
  totalOutras = "R$0,00",
  totalGeral = "R$0,00",
  liquidoApoio = "R$0,00",
}: DeducaoTableModelProps) => (
  <div>
    {/* Título principal */}
    <div className="deducao-section-title">DEDUÇÕES</div>

    {/* ATRASO ENTREGA DA DOCUMENTAÇÃO */}
    <div className="deducao-subtitle">
      <span className="deducao-dot">•</span>
      Atraso entrega da documentação:
    </div>
    <div className="table-responsive">
      <table className="deducao-doc-table">
        <thead>
          <tr>
            <th>DATA ENVIO DOC.</th>
            <th>DATA LIMITE</th>
            <th>DIAS DE ATRASO</th>
            <th>% DEDUÇÃO</th>
            <th>VALOR TOTAL DO APOIO</th>
            <th>VALOR A DEDUZIR</th>
          </tr>
        </thead>
        <tbody>
          {atrasoDocs.map((item, idx) => (
            <tr key={idx}>
              <td>{item.dataEnvio}</td>
              <td>{item.dataLimite}</td>
              <td>{item.diasAtraso}</td>
              <td>{item.percentual}</td>
              <td>{item.valorApoio}</td>
              <td>{item.valorDeducao}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {/* TÍTULOS EM ABERTO */}
    <div className="deducao-subtitle">
      <span className="deducao-dot">•</span>
      Títulos em aberto:
    </div>
    <div className="table-responsive">
      <table className="deducao-doc-table">
        <thead>
          <tr>
            <th>FILIAL</th>
            <th>Nº TÍTULO</th>
            <th>NATUREZA</th>
            <th>EMISSÃO</th>
            <th>VENCIMENTO</th>
            <th>ATRASO (dias)</th>
            <th>VALOR</th>
            <th>HISTÓRICO</th>
          </tr>
        </thead>
        <tbody>
          {titulosEmAberto.map((item, idx) => (
            <tr key={idx}>
              <td>{item.filial}</td>
              <td>{item.titulo}</td>
              <td>{item.natureza}</td>
              <td>{item.emissao}</td>
              <td>{item.vencimento}</td>
              <td>{item.atrasoDias}</td>
              <td>{item.valor}</td>
              <td>{item.historico}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="total-row">
            <td colSpan={7} style={{ textAlign: "right" }}>
              VALOR TOTAL A DEDUZIR
            </td>
            <td>{totalTitulos}</td>
          </tr>
        </tfoot>
      </table>
    </div>

    {/* OUTRAS DEDUÇÕES */}
    <div className="deducao-subtitle">
      <span className="deducao-dot">•</span>
      Outras deduções:
    </div>
    <div className="table-responsive">
      <table className="deducao-doc-table">
        <thead>
          <tr>
            <th>DESCRIÇÃO</th>
            <th>VALOR</th>
          </tr>
        </thead>
        <tbody>
          {outrasDeducoes.map((item, idx) => (
            <tr key={idx}>
              <td>{item.descricao}</td>
              <td>{formatar(item.valor)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="total-row">
            <td> VALOR TOTAL A DEDUZIR</td>
            <td>{totalOutras}</td>
          </tr>
        </tfoot>
      </table>
    </div>

    {/* Totalizador Final */}
    <div className="table-responsive">
      <table className="deducao-totalizador-table">
        <tbody>
          <tr>
            <td>ATRASO ENTREGA DA DOCUMENTAÇÃO</td>
            <td>{totalAtraso}</td>
          </tr>
          <tr>
            <td>TÍTULOS EM ABERTO</td>
            <td>{totalTitulos}</td>
          </tr>
          <tr>
            <td>OUTRAS DEDUÇÕES</td>
            <td>{totalOutras}</td>
          </tr>
          <tr className="total-deducoes-row">
            <td>VALOR TOTAL DAS DEDUÇÕES</td>
            <td className="valor-vermelho">{totalGeral}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div className="total-liquido-apoio">
      <div className="total-liquido-apoio-label">TOTAL LÍQUIDO DO APOIO</div>
      <div className="total-liquido-apoio-valor">{liquidoApoio}</div>
    </div>
  </div>
);

export default DeducaoTable;
